import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SettingsIcon extends BaseIcon {
    getChildren = () => [<path fill={this.getColor()}
                               style={{
                                   fillRule: 'evenodd',
                                   clipRule: 'evenodd'
                               }}
                               d="M19.3,15.1c0.1-0.3,0.2-0.7,0.3-1c0-0.1,0-0.1,0-0.2c0.1-0.3,0.2-0.7,0.2-1h1.2l1.9-1l-1.9-1h-1.2
  c0-0.4-0.1-0.7-0.2-1c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.2-0.7-0.3-1l1-0.6l1.2-1.8l-2.1,0.1l-1,0.6c-0.5-0.6-1-1.1-1.6-1.6l0.6-1
  l0.1-2.1l-1.8,1.2l-0.6,1c0,0,0,0,0,0c-0.3-0.1-0.6-0.2-1-0.3c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1-0.2V2.9L12,1l-1,1.9v1.2
  c-0.4,0-0.7,0.1-1,0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.2-1,0.3l-0.6-1L6.5,2.5l0.1,2.1l0.6,1l0,0c-0.6,0.5-1.1,1-1.6,1.6l-1-0.6
  L2.5,6.5l1.2,1.8l1,0.6c-0.1,0.3-0.2,0.7-0.3,1c0,0.1,0,0.1,0,0.2c-0.1,0.3-0.2,0.7-0.2,1H2.9L1,12l1.9,1h1.2c0,0.4,0.1,0.7,0.2,1
  c0,0.1,0,0.1,0,0.2c0.1,0.3,0.2,0.7,0.3,1l-1,0.6l-1.2,1.8l2.1-0.1l1-0.6l0,0c0.5,0.6,1,1.1,1.6,1.6l-0.6,1l-0.1,2.1l1.8-1.2l0.6-1
  c0.3,0.1,0.6,0.2,1,0.3c0.1,0,0.1,0,0.2,0c0.3,0.1,0.7,0.2,1,0.2v1.2l1,1.9l1-1.9v-1.2c0.4,0,0.7-0.1,1-0.2c0.1,0,0.1,0,0.2,0
  c0.3-0.1,0.7-0.2,1-0.3l0.6,1l1.8,1.2l-0.1-2.1l-0.6-1c0.6-0.5,1.1-1,1.6-1.6c0,0,0,0,0,0l1,0.6l2.1,0.1l-1.2-1.8L19.3,15.1z
  M12,18c-3.3,0-6-2.7-6-6s2.7-6,6-6c3.3,0,6,2.7,6,6S15.3,18,12,18z M16,12c0,2.2-1.8,4-4,4s-4-1.8-4-4s1.8-4,4-4S16,9.8,16,12z
  M15,12c0,1.7-1.3,3-3,3s-3-1.3-3-3s1.3-3,3-3S15,10.3,15,12z"/>]
    getViewBox = () => '0 0 24 24'
}
